import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4150" />
      <ArchitectureDiagram data-id="element-4151" />
      <HowItWorksConnections mode="how" data-id="element-4152" />
      <LivesInSlack data-id="element-4153" />
      <ComputerUse data-id="element-4154" />
      <CapabilityGrid data-id="element-4155" />
      <NarrativeSection data-id="element-4156" />
      <ToolComparison data-id="element-4157" />
      <WallOfLove data-id="element-4158" />
      <PricingSection data-id="element-4159" />
      <ClosingCTA data-id="element-4160" />
    </>;
}